import React from 'react';
import SubjectPage from '../structure/SubjectPage';
import Accordions from '../../../components/Dropdowns';

const AppliedPhysicsII = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Quantum Mechanics: Introduction: Wave particle duality, de Broglie waves, the experiment of Davisson and Germer, electron diffraction, physical interpretation of the wave function, properties, the wave packet, group and phase velocity, the uncertainty principle. The Schrödinger wave equation (1D), Eigen values and Eigen functions, expectation values, simple Eigen value problems – solutions of the Schrödinger’s equations for the free particle, the infinite well, the finite well, tunneling effect, the scanning electron microscope, the quantum simple harmonic oscillator (qualitative), zero point energy.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Quantum Statistics: The need for statistics, statistical distributions: Maxwell Boltzmann, Bose-Einstein and Fermi-Dirac statistics, their comparisons, Fermions and Bosons, Applications of quantum statistics: 1. Molecular speed and energies in an ideal gas; 2. The Black body spectrum, the failure of classical statistics to give the correct explanations – Bose-Einstein statistics applied to the Black Body radiation spectrum; Fermi-Dirac distribution, free electron theory, electronic specific heats, Fermi energy and average energy; Dying stars.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Crystal Structure: Types of solids, Unit cell, Types of crystals, Translation vectors, Lattice planes, Miller indices, Simple crystal structures, Interplaner spacing, Crystal structure analysis: Bragg’s law, Laue method, Point defects: Schottcky and Frankel defects.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Band Theory of Solids: Origin of energy bands in solids, motion of electrons in a periodic potential – the Kronig–Penny model (Qualitative). Brillouin zones, effective mass, metals, semi-conductors and insulators and their energy band structures. Extrinsic and Intrinsic semiconductors, doping – Fermi energy for doped and undoped semiconductors, the p-n junction (energy band diagrams with Fermi energy), the unbiased diode, forward and reverse biased diodes – tunnel diodes, zener diode, photo diode its characteristics, LED</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: <Accordions accordionContent={accordionContent} />,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'videos',
      label: 'Video Lectures',
      content: null, // Managed by SubjectPage
    }
  ];

  return (
    <SubjectPage
      subjectName="Applied Physics-II"
      subjectKey="appliedphysics2"
      branch="CSE"
      semester="2nd Semester"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'AppliedPhysicsIINotes',
        videos: 'AppliedPhysicsIIVideos'
      }}
    />
  );
};

export default AppliedPhysicsII;